import * as React from 'react';
import { useMobileLine } from './mobile-line';

function getServerSnapshot(): boolean {
  return false;
}

/**
 * Whether the viewport is below the app's mobile line, following it as the
 * window resizes; false off the browser.
 */
export function useIsMobile(): boolean {
  const { query } = useMobileLine();

  const subscribe = React.useCallback(
    (onChange: () => void) => {
      const media = window.matchMedia(query);
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    },
    [query],
  );
  const getSnapshot = React.useCallback(() => window.matchMedia(query).matches, [query]);

  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
